import { AxiosResponse } from 'axios'
import { LoginProps } from '../contexts/Auth'
import { ApiService } from './ApiService'

export interface SSOLoginData {
  accessToken: string
  account: {
    name: string
    username: string
    localAccountId: string
  }
}

class AuthService {
  currentToken = null

  login(data: LoginProps): Promise<AxiosResponse> {
    return ApiService.post('api/v1/auth/login', data)
  }

  loginSSO(data: SSOLoginData): Promise<AxiosResponse> {
    return ApiService.post('api/v1/auth/sso-login', {
      azureToken: data.accessToken,
      userInfo: data.account
    })
  }

  setToken(token: string): void {
    if (token !== this.currentToken) {
      ApiService.setToken(token)
    }
  }

  logout() {
    ApiService.setToken(null)
  }
}

export const authService = new AuthService()
